<template>
  <div id="app">
    <router-view />
    <LoginDialog />
  </div>
</template>

<script>
import LoginDialog from '@/components/loginDialog'

export default {
  name: 'App',
  components: { LoginDialog }
}
</script>

<style lang="scss">
body {
  // overflow-y: scroll;
  padding: 0 !important;
}

html {
  box-sizing: border-box;
  overflow-y: scroll;
}

html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100vh;
}

#app {
  width: 100%;
  min-height: 100vh;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
